import { actions } from './actions'

const initialState = {
  formasPago: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function formasPagoReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FORMAS_PAGO_LOAD_REQUESTED:
      return { ...state, formasPago: { ...state.formasPago, loading: true } }
    case actions.FORMAS_PAGO_LOAD_SUCCEEDED:
      return {
        ...state,
        formasPago: { ...state.formasPago, data: action.payload, loading: false },
      }
    case actions.FORMAS_PAGO_LOAD_FILED:
      return {
        ...state,
        formasPago: { ...state.formasPago, loading: false, error: action.error },
      }
    default:
      return state
  }
}
